module.exports = __webpack_public_path__ + "static/07-low-chlorophyll-content-5f729ac1e614de67d5f58f427f5eafd0.png";